import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit, useAuth} from './modules/auth'
import {Steps} from 'intro.js-react'
import {useTutorial} from './modules/tutorial/hooks/useTutorial'
import { PrivacyPolicyModal } from '../_metronic/partials/modals/privacy-policy/PrivacyPolicyModal'
import { TaskEditModal } from './modules/project/components/tasks-list/task-edit-modal/TaskEditModal'
import { TaskCloneModalWrapper } from './modules/project/components/tasks-list/task-clone-modal/TaskCloneModalWrapper'

const App = () => {
  const {currentUser} = useAuth()
  const {stepsEnabled, steps, handleExit, setStepsEnabled} = useTutorial()

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
            {currentUser && !currentUser.privacy_agreement && (
              <PrivacyPolicyModal />
            )}

            {currentUser && (
              <>
                <TaskEditModal />
                <TaskCloneModalWrapper />
              </>
            )}

            {currentUser && currentUser.privacy_agreement && !!currentUser.onboarded && (
              <Steps
                enabled={stepsEnabled}
                steps={steps}
                initialStep={0}
                onExit={handleExit}
                onBeforeExit={() => setStepsEnabled(false)}
                options={{
                  tooltipClass: 'tr-tour-tooltip',
                  highlightClass: 'tr-tour-highlight',
                  nextLabel: 'Avançar',
                  prevLabel: 'Voltar',
                  doneLabel: 'Concluir',
                  skipLabel: 'Pular',
                  hidePrev: true,
                  showBullets: false,
                  showProgress: true,
                  scrollToElement: true,
                  exitOnOverlayClick: false,
                }}
              />
            )}
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  )
}

export {App}
